;(function () {
  angular.module('app').constant('presenceStatuses', {
    online: 'online',
    offline: 'offline'
  })
}).call(this)
